import { format as formatFns, intervalToDuration } from "date-fns";
import { dateFormat, dateOnlyFormat } from "./constants";

/**
 * Date formatting
 */
export default class DateUtils {
  /**
   * format
   * @param date
   * @param format
   * @returns
   */
  static format(
    date: string | Date = new Date(),
    userDateFormat?: string,
    showTime = false
  ) {
    if (!date || date === undefined) {
      return "-";
    }

    let format = userDateFormat || dateOnlyFormat;
    if (showTime) {
      format = `${format} HH:mm:ss`;
    }

    if (date.constructor.name == "String") {
      date = DateUtils.getDateStringWithOutTimezone(date as string);
    }
    return formatFns(new Date(date), format);
  }
  /**
   * format
   * @param date
   * @param format
   */
  static getInterval(startDate = new Date(), endDate = new Date()) {
    return intervalToDuration({
      start: startDate,
      end: endDate,
    });
  }

  static getISTFormatted(utcDate: string | Date): string {
    // Convert the UTC date string to a Date object
    const date = new Date(utcDate);

    // Get the time in milliseconds and adjust for the IST offset (+5 hours 30 minutes)
    const istOffset = 5.5 * 60 * 60 * 1000; // IST offset in milliseconds
    const istDate = new Date(date.getTime() + istOffset);

    // Custom formatting logic
    const day = String(istDate.getDate()).padStart(2, "0");
    const monthNames = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];
    const month = monthNames[istDate.getMonth()];
    const year = istDate.getFullYear();

    // Get hours, minutes, and seconds in 24-hour format
    const hours = String(istDate.getHours()).padStart(2, "0");
    const minutes = String(istDate.getMinutes()).padStart(2, "0");
    const seconds = String(istDate.getSeconds()).padStart(2, "0");

    // Construct the formatted date string
    return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
  }

  /**
   * get inveral string
   */

  static getIntervalString(timeInterval: Object) {
    const timeDifference = Object.entries(timeInterval).filter(
      (item) => item[1] > 0
    )[0];
    return timeDifference
      ? `${timeDifference[1]} ${timeDifference[0]} ago`
      : `1 second ago`;
  }
  /**
   * otp timmer
   * @param remaining
   * @returns
   */
  static timer(remaining: any, callBack: Function) {
    let m: any = Math.floor(remaining / 60);
    let s: any = remaining % 60;

    m = m < 10 ? "0" + m : m;
    s = s < 10 ? "0" + s : s;

    callBack({
      remainingTimeInString: m + ":" + s,
      status: "running",
    });

    remaining -= 1;

    if (remaining >= 0) {
      setTimeout(() => {
        DateUtils.timer(remaining, callBack);
      }, 1000);
      return;
    }

    callBack({
      status: "finish",
    });
  }

  // get date string without imezone
  static getDateStringWithOutTimezone(dateString: string) {
    if (dateString.charAt(dateString.length - 1).toUpperCase() == "Z")
      return dateString.substring(0, dateString.length - 1);

    return dateString;
  }

  /**
   * get current date
   * @returns
   */
  static getCurrentDate() {
    return new Date();
  }

  static getDateString(date: Date = new Date()) {
    if (date) {
      let year: number | string = date.getFullYear();
      let month: number | string = date.getMonth() + 1;
      let dt: number | string = date.getDate();

      if (dt < 10) {
        dt = "0" + dt;
      }
      if (month < 10) {
        month = "0" + month;
      }

      const formattedDate = year + "-" + month + "-" + dt;
      return formattedDate;
    }
  }
}
